import {weekdays} from './weekdays.ts'
import type {UserSettings} from '@package/shared'

export const getLocalWeekdays = (userSettings: UserSettings) => {
  return [
    ...weekdays.slice(userSettings.firstDayOfWeek), //
    ...weekdays.slice(0, userSettings.firstDayOfWeek),
  ].map((weekday) => ({
    weekday,
    weekdayIndex: weekdays.indexOf(weekday) as 0 | 1 | 2 | 3 | 4 | 5 | 6,
  }))
}
